import React from 'react';
import { cn } from '@/shadcn/lib/utils';

interface ResponsiveGridProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

const ResponsiveGrid = React.forwardRef<HTMLDivElement, ResponsiveGridProps>(
  ({ children, className, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4', // sensible defaults
        className
      )}
      {...props}
    >
      {children}
    </div>
  )
);

ResponsiveGrid.displayName = 'ResponsiveGrid';

export { ResponsiveGrid };
